import React from 'react';
import { X, ArrowClockwise, ArrowCounterClockwise } from '@phosphor-icons/react';
import {Document, KnowledgebaseFormData} from '../../../../Types';

import {useSelector} from "react-redux";


function FileListItem({formData, document, handleReembedDocument, handleRemoveExistingDocument}: {formData: KnowledgebaseFormData, document: Document, handleReembedDocument: (identifier: string) => void, handleRemoveExistingDocument: (identifier: string) => void}) {
    const i18n = useSelector((state: any) => state.i18n.i18n);

    const shouldReembed = formData.documentsToReembed.includes(document.identifier)

    return (
        <div
            key={document.identifier}
            className={'flex my-2 items-center justify-between bg-input-backgroundColor rounded-lg px-4 py-3 w-full '+ (formData.documentsToReembed.includes(document.identifier) ? 'border-primary border-2' : '')}
        >
            <span className="text-sm flex-grow">
                {document.filename}
            </span>
            <div className="flex items-center gap-3">
                <div
                    className={`w-3 h-3 rounded-full tooltip ${
                        document.status === 'in_progress'
                            ? 'bg-orange-400'
                            : document.status === 'error'
                                ? 'bg-red-500'
                                : 'bg-green-500'
                    }`}
                    data-tooltip-content={i18n.translate({
                        id: 'document.status.' + document.status,
                        fallback: document.status,
                        sourceName: 'Knowledgebase',
                    })}
                />
                {document.status==="error"&&<button
                    onClick={() =>
                        handleReembedDocument(document.identifier)
                    }
                    className="text-gray-500 hover:text-gray-700 tooltip"
                    data-tooltip-content={i18n.translate({
                        id: shouldReembed ? 'notReembed' : 'reembed',
                        sourceName: 'Knowledgebase',
                    })}
                >
                    {shouldReembed ? <ArrowCounterClockwise size={16} /> : <ArrowClockwise size={16} /> }
                </button>}
                <button
                    onClick={() =>
                        handleRemoveExistingDocument(document.identifier)
                    }
                    className="text-gray-500 hover:text-gray-700 tooltip"
                    data-tooltip-content={i18n.translate({
                        id: 'delete.button',
                        sourceName: 'Knowledgebase',
                    })}
                >
                    <X size={16} />
                </button>
            </div>
        </div>);
};

export default FileListItem;
